<template>
	<section>
		<header-page
			actions
			name="customers"
			:title="$route.meta.title"
			@run-action="runAction"
		/>
		<app-actions
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<!-- <progress-wait
		v-model="dialogLoading"
		/> -->
		<customer-list
			:columns="columns"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="table.rows.length"
			:current-page="currentPage"
			:rows="table.rows"
			:last-page="table.lastPage"
			@on-page="changePage"
			@delete-customer="openConfirmation"
			@on-search="onSearchTable"
		/>

		<action-bar
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<v-dialog
			content-class="confirmation-dialog"
			v-model="dialog"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">{{ dialogMessage }}</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<v-btn
						type="button"
						@click="closeDialog"
						color="success"
						class="btn-action mr-1 white--text">
						Cancelar
					</v-btn>
					<v-btn
						type="button"
						color="error"
						@click="onDelete"
						class="btn-action ml-1 white--text">
						Eliminar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
import actionBar from '@/components/shared/action-bar/action-bar';
import customerList from '@/components/customers/customer-list';
import appActions from '@/components/shared/app-actions/app-actions';
import progressWait from '@/components/shared/progress-wait/progress-wait';
import { mapActions, mapGetters } from 'vuex';


async function created() {
	const { headers } = await this.loadData('customer');
	this.itemsTotalQuantity = Number(headers['x-quantity']);
	await this.$currentSubsidiary({});
	if (this.currentSubsidiary.id) {
		this.setId(
			{ documentNumber: this.currentSubsidiary.documentNumber, id: this.currentSubsidiary.id },
			'subsidiaryId',
		);
	}
	if (this.getGlobalSubsidiaries.length === 1) {
		const currentSubsidiary = this.getGlobalSubsidiaries.find(sub => sub.companyId != null);
		this.$currentSubsidiary(currentSubsidiary);
	}
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData('customer');
}

function closeDialog() {
	this.dialog = false;
	this.dialogMessage = '';
	this.customerId = null;
}

async function onDelete() {
	try {
		await this.$http.patch(`company/${this.customerId}/unlink-customer`);
		this.showNotification('El registro ha sido eliminado correctamente');
		this.closeDialog();
		this.loadData('customer');
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}
async function subsidiaryChange(newSubsidiary) {
	if (newSubsidiary.id) {
		this.setId(
			{ documentNumber: newSubsidiary.documentNumber, id: newSubsidiary.id },
			'subsidiaryId',
		);
	}
}
function setId({ documentNumber, id }, modelName) {
	this.params[modelName] = id;
	if (modelName === 'subsidiaryId') {
		this.costSubsidiary = documentNumber;
	}
}

function onSearchTable(value) {
	this.onSearch(value, 'customer');
	this.currentPage = 1;
}

function openConfirmation({ id, lastname, name }) {
	this.customerId = id;
	this.dialogMessage = `¿Desea eliminar al cliente ${name} ${lastname} del listado?`;
	this.dialog = true;
}

function runAction({ codeWeb }) {
	this.goTo(codeWeb);
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Fecha de Inicio', value: 'createdAt', checked: true, visible: true, movil: true },
			{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true, movil: false },
			{ id: 3, name: 'Nro. Documento', value: 'documentNumber', checked: true, visible: true, movil: true },
			{ id: 4, name: 'Teléfono', value: 'phone', checked: true, visible: true, movil: false },
			{ id: 5, name: 'Correo', value: 'email', checked: true, visible: true, movil: true },
			{ id: 6, name: 'Acciones', checked: true, visible: true, flagVisible: true, movil: false },
		],
		currentPage: 1,
		customerId: null,
		dialog: false,
		dialogMessage: '',
		itemsTotalQuantity: null,
	};
}

export default {
	name: 'page-customer',
	created,
	components: {
		actionBar,
		customerList,
		appActions,
		progressWait,
	},
	data,
	methods: {
		...mapActions('subsidiary', {
			$currentSubsidiary: 'setCurrentSubsidiary',
		}),
		changePage,
		closeDialog,
		onDelete,
		onSearchTable,
		openConfirmation,
		runAction,
		subsidiaryChange,
		setId,
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
			'getGlobalSubsidiaries',
		]),
	},
	watch: {
		currentSubsidiary: subsidiaryChange,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/customers/page-customer.vue